import { post } from '..';
import { buildUrl } from '../../utils';

export const createSystemAdminValidation = (email: string) =>
  post(buildUrl('/v1/security/employees/grantSysAdmin'), {
    email,
  });

export const createSystemAdmin = (email: string) =>
  post(buildUrl('/v1/security/employees/grantSysAdmin?createRole=true'), {
    email,
  });

export const revokeSystemAdminValidation = (email: string) =>
  post(buildUrl('/v1/security/employees/revokeSysAdmin'), {
    email,
  });

export const revokeSystemAdmin = (email: string) =>
  post(buildUrl('/v1/security/employees/revokeSysAdmin?removeRole=true'), {
    email,
  });
